const emailRegex = "^undefined$|^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$";
const tenDigitMobileRegex = "^\\d{10}$";
const nameRegex = "^[A-Za-z\\s]+$";
export { nameRegex, emailRegex, tenDigitMobileRegex };
